import {Middleware} from '@helpers/middleware';
import {MyDocument} from '@appManagers/appDocsManager';
import {AppManagers} from '@lib/managers';
import lottieLoader, {LottieAssetName} from '@lib/lottie/lottieLoader';
import LottiePlayer from '@lib/lottie/lottiePlayer';
import rootScope from '@lib/rootScope';
import wrapSticker from '@components/wrappers/sticker';

export default async function wrapLocalSticker({
  container,
  emoji,
  width,
  height,
  assetName,
  middleware,
  managers = rootScope.managers,
  loop = false,
  autoplay = true
}: {
  container?: HTMLElement,
  doc?: MyDocument,
  // url?: string,
  emoji?: string,
  assetName?: LottieAssetName,
  width: number,
  height: number,
  managers?: AppManagers,
  middleware?: Middleware,
  autoplay?: boolean,
  loop?: boolean
}) {
  container ||= document.createElement('div');
  container.classList.add('media-sticker-wrapper');

  let playerPromise: Promise<LottiePlayer>;
  if(assetName) {
    playerPromise = lottieLoader.loadAnimationAsAsset({
      container,
      loop,
      autoplay,
      width,
      height,
      noCache: true,
      middleware
    }, assetName).then((animation) => {
      return lottieLoader.waitForFirstFrame(animation);
    });
  } else if(emoji) {
    const doc = await managers.appStickersManager.getAnimatedEmojiSticker(emoji);
    if(doc) playerPromise = wrapSticker({
      doc,
      div: container,
      loop,
      play: autoplay,
      width,
      height,
      emoji,
      managers,
      middleware
    }).then((result) => {
      return result.render as Promise<LottiePlayer>;
    });
  }

  return {container, promise: playerPromise};
}
